import React from 'react'

import influencerData from '../../data-influencer/pure-flow'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const PureFlow = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default PureFlow
